import script from "./gamePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./gamePanel.vue?vue&type=script&setup=true&lang=ts"

import "./gamePanel.vue?vue&type=style&index=0&id=c0a192f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0a192f4"]])

export default __exports__